import { render, staticRenderFns } from "./questionTwoSteps.vue?vue&type=template&id=46c2c456&scoped=true&"
import script from "./questionTwoSteps.vue?vue&type=script&lang=js&"
export * from "./questionTwoSteps.vue?vue&type=script&lang=js&"
import style0 from "./questionTwoSteps.vue?vue&type=style&index=0&id=46c2c456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c2c456",
  null
  
)

export default component.exports